'use strict';

var cov_13mb1tye9v = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/organizationEmail/organizationEmail.js',
        hash = '0ffba5c44ec421f28097048ecf9a13db69f23187',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/organizationEmail/organizationEmail.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 51
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 39
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 21
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 3
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrganizationEmailController = function () {
    function OrganizationEmailController() {
        _classCallCheck(this, OrganizationEmailController);
    }

    _createClass(OrganizationEmailController, [{
        key: 'toogleVerified',
        value: function toogleVerified() {
            cov_13mb1tye9v.f[0]++;
            cov_13mb1tye9v.s[0]++;

            this.email.verified = !this.email.verified;
            cov_13mb1tye9v.s[1]++;
            this.email.$save(['verified']);
        }
    }]);

    return OrganizationEmailController;
}();

cov_13mb1tye9v.s[2]++;


angular.module('app').component('organizationEmail', {
    controller: OrganizationEmailController,
    templateUrl: 'app/components/organizationEmail/organizationEmail.html',
    bindings: {
        email: '<'
    }
});